export default __webpack_public_path__ + "static/media/background.fff4e828.jpg";